<av-card [attr.aria-label]="'Disclaimer' | translate" [backdrop]="false">
  <av-card-body
    type="container"
    #bodyRef
    (scroll)="checkScrollPosition()"
    [attr.tabindex]="scrollRequired() ? 0 : null"
  >
    <div [innerHTML]="text"></div>
  </av-card-body>
  @if (checkboxes().length) {
  <ul class="consent-list">
    @for (checkbox of checkboxes(); track checkbox.id; let i = $index) {
    <li>
      <label class="consent-item">
        <input
          type="checkbox"
          [checked]="isChecked(checkbox)"
          (change)="checkboxChanged(checkbox, $any($event.target).checked)"
          [attr.data-tid]="'disclaimer/checkbox/' + i"
        />
        <span>
          <span [innerHTML]="checkbox.label"></span>
          @if (checkbox.required) {
          <span class="consent-required" aria-hidden="true">*</span>
          }
        </span>
      </label>
    </li>
    }
  </ul>
  }
  <av-card-footer class="fx-row fx-justify-space-between fx-align-center">
    <button avButton (click)="exit()" translate data-tid="disclaimer/exit">
      Exit
    </button>
    <div class="fx-row fx-align-center fx-gap-sm">
      @if (acceptDisabled()) {
      <div class="consent-hint text-muted" data-tid="disclaimer/hint">
        @if (scrollRequired() && !scrolledToEnd()) {
        <span translate>Scroll to the end of the text to continue</span>
        } @else {
        <span translate>Please accept all the required terms to continue</span>
        }
      </div>
      }
      <button
        avButton
        (click)="accept()"
        color="accent"
        [disabled]="acceptDisabled()"
        translate
        data-tid="disclaimer/accept"
        #acceptRef
      >
        Agree & Continue
      </button>
    </div>
  </av-card-footer>
</av-card>
